
import { Helmet } from "react-helmet-async";
import ProgramPDFTemplate from "@/components/ProgramPDFTemplate";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const ProgramPDF = () => {
  return (
    <>
      <Helmet>
        <title>Program Overview | The Monastery Method™</title>
        <meta name="description" content="A comprehensive overview of The Monastery Method™ program, integrating ancient monastic wisdom into modern leadership." />
        <meta name="robots" content="noindex" />
        <style>
          {`
            @media print {
              @page {
                size: letter portrait;
                margin: 0.75in 0.75in 0.9in 0.75in;
              }
              body {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
                color-adjust: exact !important;
                font-size: 11pt;
                line-height: 1.5;
              }
              
              /* Core print styles */
              .print-container {
                max-width: 100% !important;
                margin: 0 !important;
                padding: 0 !important;
              }
              
              /* Element-specific print adjustments */
              h1 { font-size: 24pt !important; }
              h2 { font-size: 18pt !important; }
              h3 { font-size: 14pt !important; }
              h4 { font-size: 12pt !important; }
              p, li { font-size: 11pt !important; }
              
              /* Layout control */
              section { 
                page-break-inside: avoid;
                margin-bottom: 20pt;
              }
              h1, h2, h3, h4 { page-break-after: avoid; }
              img { max-width: 100% !important; }
              
              /* Hide screen-only elements */
              .print-hidden, .screen-only, button, .button {
                display: none !important;
              }
              
              /* Show print-only elements */
              .print-only {
                display: block !important;
              }
              
              /* Background colors */
              .bg-gray-50 {
                background-color: #f9fafb !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
            }
          `}
        </style>
      </Helmet>
      
      {/* Screen-only controls */}
      <div className="screen-only print:hidden container mx-auto px-6 py-6 max-w-4xl">
        <div className="flex justify-between items-center mb-8">
          <Link to="/" className="text-charcoal/80 hover:text-charcoal transition-colors">
            &larr; Back to Home
          </Link>
          <Button 
            onClick={() => window.print()} 
            variant="outline"
            className="inline-flex items-center bg-charcoal text-white px-6 py-2 text-sm uppercase tracking-widest transition-all duration-300 hover:bg-charcoal/90 border-none"
          >
            Print PDF <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
        
        <div className="bg-accent/5 p-6 rounded-lg mb-8 border border-accent/10">
          <h2 className="text-xl font-serif mb-3">PDF Preview</h2>
          <p className="text-charcoal/80 text-sm">
            Below is a preview of how your PDF will look when printed. Click the "Print PDF" button above to save or print this document.
          </p>
        </div>
      </div>
      
      {/* PDF Content Container - optimized for print */}
      <div className="print-container container mx-auto px-6 max-w-[8.5in] bg-white">
        <ProgramPDFTemplate />
      </div>
    </>
  );
};

export default ProgramPDF;
